/**
 * @phxPlatform
 */

export * from './platform_utility';



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-platform/src/main.ts